import { KitSize } from 'components/uiKit/KitTypes'
import { Typography } from 'components/uiKit/Typography'
import { t } from 'services/Translation'

import * as s from './TestGeneralFeedbackElement.module.scss'
import AlertIcon from './assets/eye-block.svg'

const TestGeneralFeedbackElementEditor = () => {
  return (
    <div className={s.alert}>
      <img alt='alertIcon' src={AlertIcon} />
      <Typography size={KitSize.S} styleType='hint'>
        {t('elements.testGeneralFeedback.empty')}
      </Typography>
    </div>
  )
}

export default TestGeneralFeedbackElementEditor
